import { createSlice } from "@reduxjs/toolkit";
import { getVOCReasons } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IOperator } from "api/types/_operator";


export interface IState {
  vocReasons: ResponseData<IOperator[]> & PaginationResponse | null,
  isVOCReasonLoading: boolean,
  isVOCReasonSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  vocReasons: null,
  isVOCReasonLoading: false,
  isVOCReasonSuccess: false,

  error: {},
};

const VOCReasonSlice = createSlice({
  name: "VOCReason",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get vocReasons
    builder.addCase(getVOCReasons.pending, (state: IState, action: any) => {
      state.isVOCReasonLoading = true
    });
    builder.addCase(getVOCReasons.fulfilled, (state: IState, action: any) => {
      state.vocReasons = action.payload.data;
      state.isVOCReasonSuccess = true;
      state.isVOCReasonLoading = false;
    });
    builder.addCase(getVOCReasons.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isVOCReasonSuccess = false;
      state.isVOCReasonLoading = false;
    });
  },
});

export default VOCReasonSlice.reducer;
